import React, { useState, useEffect, useCallback } from "react";
import config from "environment";
import { toastFail } from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../ds2/components";
import "../../index.css";
import "./SlackLanding.css";
import { apiSlackAuth } from "../../services/OAuthService";
import { postRequest } from "../../services/client";
import { CircularProgress } from "@mui/material";
import { apiGetUser } from "../../api";
import { selectUser, setUser } from "../../redux/features/appData";
import { TRACK_EVENTS, trackAnalyticsEvent } from "../../hooks/useAnalytics";
import toast from "react-hot-toast";

export default function SlackLanding() {
  const storeUser = useSelector(selectUser);
  const dispatch = useDispatch();

  const workspaceId = storeUser?.currentWorkspaceId;
  const userId = storeUser?.id;

  const [statusText, setStatusText] = useState<string>("Loading...");
  const [showProgress, setShowProgress] = useState<boolean>(true);

  const codeFromSlack = new URLSearchParams(window.location.search).get("code");
  const navigate = useNavigate();

  const authSlack = useCallback(
    async (code: string, userId: string, workspaceId: string) => {
      console.log("[SlackLanding] Starting Slack auth", {
        code: code.substring(0, 10) + "...",
        userId,
        workspaceId,
      });

      try {
        const result = await apiSlackAuth(code, userId, workspaceId);
        console.log("[SlackLanding] Auth API result:", result);

        if (result) {
          setStatusText("Slack is Authed!");
          const apiUser = await apiGetUser(userId);
          console.log("[SlackLanding] User after auth:", {
            userId: apiUser?.id,
            slackUserId: apiUser?.slackUserId,
          });
          dispatch(setUser(apiUser));
          navigate("/waz/settings/workspaces");
        } else {
          console.error("[SlackLanding] Slack auth returned false");
          setStatusText("Slack auth failed! 😢");
          setShowProgress(false);
          toast("Slack auth failed!", toastFail);
        }
      } catch (error) {
        console.error("[SlackLanding] Error during Slack auth:", error);
        setStatusText("Slack auth error! 😢");
        setShowProgress(false);
        toast("Slack auth error: " + (error as Error).message, toastFail);
      }
    },
    [dispatch, navigate]
  );

  const apiBetterUpSlackAuth = async (
    code: string,
    userId: string,
    workspaceId: string
  ): Promise<boolean> => {
    const fetchURL = `${config.baseApi}/slack/betterup/auth`;
    return await postRequest(
      fetchURL,
      { code, userId, workspaceId },
      "API/apiBetterUpSlackAuth"
    );
  };

  const authBetterUpSlack = async (
    code: string,
    userId: string,
    workspaceId: string
  ) => {
    const result = await apiBetterUpSlackAuth(code, userId, workspaceId);

    if (result) {
      setStatusText("BetterUp Slack is Authed!");
      const apiUser = await apiGetUser(userId);
      dispatch(setUser(apiUser));
      navigate("/workspaces");
    } else {
      setStatusText("BetterUp Slack auth failed! 😢");
      setShowProgress(false);
    }
  };

  useEffect(() => {
    if (codeFromSlack && userId && workspaceId) {
      // Check if this is a BetterUp Slack OAuth callback
      const isBetterUpAuth = window.location.pathname.includes("/betterup/");

      if (isBetterUpAuth) {
        authBetterUpSlack(codeFromSlack, userId, workspaceId);
        trackAnalyticsEvent(
          TRACK_EVENTS.CompletedSlackIntegration,
          { type: "betterup" },
          storeUser
        );
      } else {
        authSlack(codeFromSlack, userId, workspaceId);
        trackAnalyticsEvent(
          TRACK_EVENTS.CompletedSlackIntegration,
          {},
          storeUser
        );
      }
    } else {
      setStatusText("Missing information from slack redirect");
      toast("Slack auth failed!", toastFail);
      navigate("/workspaces");
    }
  }, [codeFromSlack, userId, workspaceId, storeUser, authSlack, navigate]);

  return (
    <div id="slack-landing-page">
      <div className="slack-landing-page-body">
        <div className="slack-landing-page-text">
          <h1>We're working on Authing Slack for you!</h1>
        </div>
        <div className="slack-landing-status-text">Status: {statusText}</div>

        {showProgress && <CircularProgress />}
        {!showProgress && (
          <div className="slack-landing-status-button">
            <Button
              variant="primary"
              onClick={() => navigate("/waz/settings/personal")}>
              Go To Settings
            </Button>

            {/* <button onClick={() => navigate("/waz/settings/personal")}>
              Go To Settings
            </button> */}
          </div>
        )}
      </div>
    </div>
  );
}
